import { render, staticRenderFns } from "./SaaSGuide.vue?vue&type=template&id=704833d2&scoped=true"
import script from "./SaaSGuide.vue?vue&type=script&lang=js"
export * from "./SaaSGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704833d2",
  null
  
)

export default component.exports